<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>

        <tt-list-legacy [hidden]="selectedBgInvoiceMakeMultiMain !== 'SELECT'" [listItems]="itemsListCreateMultiInvoices" ltype="multi" [optionfunc]="toggleChosen.bind(this)"></tt-list-legacy>
        <tt-list-legacy [hidden]="selectedBgInvoiceMakeMultiMain !== 'VIEW'" [listItems]="itemsListCreateMultiInvoices" ltype="multi" typevar="g"></tt-list-legacy>
    </div>

    <div class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="invoicemakemulti_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="20">
                    <tt-card class="col-xs-12 sp-0">
                        <ng-container *ngTemplateOutlet="info"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="80">
                    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!setting">
        <tt-input ttLabel="businessco_companyname" [ttModel]="setting.businessco_companyname" ttReadonly></tt-input>
        <tt-input ttLabel="invoicemethod_name" [ttModel]="setting.invoicemethod_name" ttReadonly></tt-input>
        <tt-input ttLabel="invoice_valuta_id" [ttModel]="setting.invoice_valuta_id" ttReadonly></tt-input>
        <tt-date [hidden]="setting.invoicemethod_no === '3'" ttRememberId="w_invoicemakemulti.deliverydate_tom" ttLabel="deliverydate_tom" [(ttModel)]="setting.deliverydate_tom" (ttModelChange)="onChanged($event, 'deliverydate_tom')"></tt-date>
        <tt-date ttRememberId="w_invoicemakemulti.invoice_date" ttLabel="invoice_date" [(ttModel)]="setting.invoice_date" (ttModelChange)="onChanged($event, 'invoice_date')"></tt-date>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!setting">
        <div *ngIf="itemsListCreateMultiInvoices.length > 2">
            <tt-button [hidden]="showSelectAll === true" ttText="invoicemakemulti_select_all" (ttClick)="selectAll()" ttIcon="fa fa-check"></tt-button>
            <tt-button [hidden]="showUnselectAll === true" ttText="invoicemakemulti_unselect_all" (ttClick)="unselectAll()" ttIcon="glyphicon glyphicon-unchecked"></tt-button>
            <tt-button-save ttText="invoicemakemulti_create_invoices" (ttClick)="createItemsListInvoices()" [ttLoading]="creating"></tt-button-save>
        </div>

        <tt-tabs [(ttSelectedId)]="selectedBgInvoiceMakeMultiMain">
            <tt-tab ttId="SELECT" ttLabel="bg_invoicemakemulti_main_select"></tt-tab>
            <tt-tab ttId="VIEW" ttLabel="bg_invoicemakemulti_main_view"></tt-tab>
        </tt-tabs>
    </ng-container>
</ng-template>
